import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/review/timecards")({
  component: () => <Outlet />,
});
